import { Link } from "@tanstack/react-router";
import { forwardRef } from "react";
import { resolveCurrentBoardThreadRoute } from "@/shared/lib/currentBoardThreadRoute";

type CurrentBoardThreadLinkProps = Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  "href"
> & {
  threadId: string;
};

/**
 * 現在の板スコープ(mixではアンカー板、板mountではその板)のスレページへ
 * router遷移するLink。mix配下では常にアンカー板slug付きの
 * `/mix/{slug}/thread/{id}` を生成し、`/mix/thread/{id}` のslug無し形が
 * 混入するのを防ぐ。板mountではbasepath `/b/{slug}` が付与されるため
 * 従来の `/thread/$threadId` のままとする。
 *
 * 本番ビルドはreactをpreact/compatへ差し替えており、Preact 10は関数
 * componentへのref-as-propを実装していない(refをpropsへ戻すのは
 * forwardRef/memo/lazyのみ)。素の関数componentのままだと呼び出し元の
 * refにanchorではなくPreactの内部instanceが入るため、必ずforwardRefで
 * 受けて実anchorへ渡す(CatalogThreadLink.tsxと同じ理由)。
 */
export const CurrentBoardThreadLink: React.ForwardRefExoticComponent<
  CurrentBoardThreadLinkProps & React.RefAttributes<HTMLAnchorElement>
> = forwardRef(function CurrentBoardThreadLink(
  { threadId, children, ...anchorProps }: CurrentBoardThreadLinkProps,
  ref: React.Ref<HTMLAnchorElement>,
): React.ReactNode {
  const route = resolveCurrentBoardThreadRoute(threadId);
  if (route.to === "/$slug/thread/$threadId") {
    return (
      <Link ref={ref} to={route.to} params={route.params} {...anchorProps}>
        {children}
      </Link>
    );
  }
  return (
    <Link ref={ref} to={route.to} params={route.params} {...anchorProps}>
      {children}
    </Link>
  );
});
